export default __webpack_public_path__ + "static/media/Path 84.b3626b48.svg";